export const initialState = {
  header: {
    changed: false
  },
  details: []
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnHeaderPropertyChanged':
      return onHeaderPropertyChanged(state, action);
    case 'OnHeaderSaved':
      return onHeaderSaved(state, action);
    case 'OnDetailsPropertyChanged':
      return onDetailsPropertyChanged(state, action);
    case 'OnDetailSaved':
      return onDetailSaved(state, action);
    case 'OnDetailValuesChanged':
      return onDetailValuesChanged(state, action);
    case 'OnDetailAdded':
      return onDetailAdded(state, action);
    case 'OnDetailDeleted':
      return onDetailDeleted(state, action);
    case 'OnDetailValueAdded':
      return onDetailValueAdded(state, action);
    case 'OnDetailValueDeleted':
      return onDetailValueDeleted(state, action);
    case 'OnIncomeSourceAdded':
      return onIncomeSourceAdded(state, action);
    case 'OnDetailExpanded':
      return onDetailExpanded(state, action);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { income } = action;
  return {
    ...state,
    header: {
      ...state.header,
      id: income.id,
      orderNo: income.orderNo,
      code: income.code,
      name: income.name,
      description: income.description,
      incomeSourceArea: income.incomeSourceArea,
      isActive: income.isActive,
      fromExternalSource: income.fromExternalSource,
      isExpense: income.isExpense,
      hasSummary: income.hasSummary,
      partnerTypeId: income.partnerTypeId
    },
    details: income.details.map(item => {
      return { ...item, changed: false, isExpanded: false };
    })
  };
}

function onHeaderPropertyChanged(state, action) {
  const { propertyName, value } = action;
  return {
    ...state,
    header: {
      ...state.header,
      [propertyName]: value,
      changed: true
    }
  };
}

function onHeaderSaved(state) {
  return {
    ...state,
    header: {
      ...state.header,
      changed: false
    }
  };
}

function onDetailsPropertyChanged(state, action) {
  const { detailPropertyName, detailValue, index } = action;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        [detailPropertyName]: detailValue,
        changed: true
      }
    })
  };
}

function onDetailSaved(state, action) {
  const { index } = action;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        changed: false,
        isExpanded: true
      }
    })
  };
}

function onDetailValuesChanged(state, action) {
  const { detailValueName, propertyValue, detailIndex, detailValueIndex } = action;
  const newDetailValues = Object.assign([...state.details[detailIndex].detailValues]);
  return {
    ...state,
    details: Object.assign([...state.details], {
      [detailIndex]: {
        ...state.details[detailIndex],
        changed: true,
        detailValues: Object.assign([...newDetailValues], {
          [detailValueIndex]: {
            ...newDetailValues[detailValueIndex],
            [detailValueName]: propertyValue
          }
        })
      }
    })
  };
}

function onDetailAdded(state) {
  const detail = {
    code: '',
    name: '',
    dataTypeId: null,
    description: '',
    formula: null,
    id: null,
    detailValues: [],
    incomeSourceId: state.header.id,
    isActive: true,
    isReadOnly: false,
    isSummary: false,
    orderNo:
      state && state.details && state.details.length > 0
        ? Math.max.apply(
            Math,
            state.details.map(item => item.orderNo)
          ) + 1
        : 1,
    periodTypeId: null,
    validationFormula: '',
    validationMessage: '',
    changed: false,
    isExpanded: true
  };
  const newDetails = Object.assign([...state.details]);
  newDetails.push({ ...detail, changed: true });
  return {
    ...state,
    details: newDetails
  };
}

function onDetailDeleted(state, action) {
  const { index } = action;
  const newDetails = Object.assign([...state.details]);
  newDetails.splice(index, 1);
  return {
    ...state,
    details: newDetails
  };
}

function onDetailValueAdded(state, action) {
  const { index, detailId } = action;
  const detail = { id: null, code: '', name: '', detailId: detailId };
  const newDetailValues = Object.assign([...state.details[index].detailValues]);
  newDetailValues.push({ ...detail });

  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        changed: true,
        detailValues: newDetailValues
      }
    })
  };
}

function onDetailValueDeleted(state, action) {
  const { index, valueIndex } = action;
  const newDetailValues = Object.assign([...state.details[index].detailValues]);
  newDetailValues.splice(valueIndex, 1);
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        changed: true,
        detailValues: newDetailValues
      }
    })
  };
}
function onIncomeSourceAdded(state) {
  return {
    ...state,
    header: {
      ...state.header,
      id: null,
      name: '',
      code: '',
      description: '',
      orderNo: null,
      incomeSourceArea: '',
      isActive: true,
      fromExternalSource: false,
      isExpense: false,
      hasSummary: false,
      partnerTypeId: null
    },
    details: []
  };
}

const onDetailExpanded = (state, action) => {
  const { index, isExpanded } = action;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        isExpanded: isExpanded
      }
    })
  };
};
